import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import MapMiniRepsol from 'components/device/Components/MapMiniRepsol';
import { checkWorkspace, WORKSPACES_REPSOL } from 'guards/CheckRoles';
import { RootState, useSelector } from '../../../redux/store';

import dayjs from 'dayjs';

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DATE_FORMAT_NO_TIME } from '../../../@types/model/device';
import 'jspdf-autotable';
import { LoadingButton } from '@mui/lab';
function DeviceDetailsInfo(props: any) {
  const { refactoredDevice, device, dateRangeValue } = props;
  const { t } = useTranslation();

  const TIPOS_SECTOR_RECURRENCIA = [t('each_8_hours'), t('each_4_hours'), t('each_12_hours')];
  const { workspace } = useSelector((state: RootState) => state.workspace);

  const [loading, setLoading] = useState<boolean>(false);

  const iconTypes = {
    deposito: 'iconoir:gas-tank-drop',
    silo: `mdi:farm-home-outline`,
    contador: `material-symbols:water-drop-outline`,
    beer: `mdi:faucet`
  };

  let icon;
  if (refactoredDevice?.device_type === 'deposito') icon = iconTypes.deposito;
  else if (refactoredDevice?.device_type === 'silo') icon = iconTypes.silo;
  else if (refactoredDevice?.device_type === 'glp' && refactoredDevice?.device_type === 'water')
    icon = iconTypes.contador;
  else if (refactoredDevice?.device_type === 'beer') icon = iconTypes.beer;

  function obtenerTamanoImagen(url: string): Promise<{ ancho: number; alto: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const ancho = img.naturalWidth;
        const alto = img.naturalHeight;

        resolve({ ancho, alto });
      };

      img.onerror = () => {
        reject(new Error('No se pudo cargar la imagen.'));
      };

      img.src = url;
    });
  }

  useEffect(() => {}, []);

  return (
    <div className="device-detail--header">
      <div className="map">
        <div className="head">
          <Icon className="icon" icon={`${icon}`} />
          <div className="col">
            <span className="label">{t('name')}</span>
            <span className="detail">{device?.attributes.name}</span>
          </div>
          <div className="col">
            {checkWorkspace(workspace, WORKSPACES_REPSOL) && (
              <>
                {' '}
                <span className="label">{t('gasoil_type')}</span>
                <span className="detail">{t('unknown')}</span>
              </>
            )}
          </div>
        </div>
        {device ? (
          <MapMiniRepsol
            className="map"
            isMarkerShown
            googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={
              <div style={{ height: `140px`, marginTop: '20px', marginBottom: '-25px' }} />
            }
            mapElement={<div style={{ height: `100%` }} />}
            markers={[device]}
          />
        ) : null}
      </div>
      <div className="llenado cuadro-redondeado">
        <h3>{t('fill')}</h3>
        <div className="groups">
          <div className="group group-light">
            <label>{t('last_fill')}</label>
            <div className="detail">-</div>
          </div>
          <div className="group group-light">
            <label>{t('provider')}</label>
            <div className="detail">-</div>
          </div>
        </div>
        <h3>{t('measurement')}</h3>
        <div className="groups">
          <div className="group">
            <label>{t('last_measurement')}</label>
            <div className="detail">
              {device ? dayjs(device.attributes.last_data?.date).format('DD/MM/YYYY, h:mm') : null}
            </div>
          </div>
          <div className="group">
            {checkWorkspace(workspace, WORKSPACES_REPSOL) && (
              <>
                {' '}
                <label>{t('recurrence')}</label>
                {refactoredDevice?.sector && refactoredDevice?.sector !== -1 ? (
                  <div className="detail">{TIPOS_SECTOR_RECURRENCIA[refactoredDevice?.sector]}</div>
                ) : (
                  <div className="detail">-</div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="mantenimiento cuadro-redondeado">
        <h3>{t('maintenance')}</h3>
        <div className="groups">
          <div className="group">
            <label>{t('last_revision')}</label>
            {refactoredDevice?.last_revision && refactoredDevice?.last_revision !== '' ? (
              <div className="detail">
                {dayjs(refactoredDevice?.last_revision).format('DD/MM/YYYY')}
              </div>
            ) : (
              <div className="detail">-</div>
            )}
          </div>
        </div>
        <div className="groups">
          <div className="group">
            <label>{t('next_revision')}</label>
            {refactoredDevice?.next_revision && refactoredDevice?.next_revision !== '' ? (
              <div className="detail">
                {dayjs(refactoredDevice?.next_revision).format('DD/MM/YYYY')}
              </div>
            ) : (
              <div className="detail">-</div>
            )}
          </div>
        </div>
      </div>
      <div className="mantenimiento cuadro-redondeado">
        <h3>{t('reports')}</h3>
        <div className="groups">
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={() => {
              setLoading(true);
              const element = document.querySelector('#appex-chart-line');
              if (element instanceof HTMLElement) {
                html2canvas(element).then(async (canva) => {
                  function roundedRect(
                    doc: jsPDF,
                    x: number,
                    y: number,
                    width: number,
                    height: number,
                    radius: number
                  ) {
                    doc.setLineWidth(1);
                    doc.roundedRect(x, y, width, height, radius, radius, 'S');
                  }
                  const doc = new jsPDF();
                  doc.setFontSize(16);
                  let offset = 0;

                  // Uso de la función
                  try {
                    let logoUrl = workspace?.wsLogo.replace(
                      'https://cdn.giraf.io/partners/',
                      'https://api.giraf.io/api/v2/user/logo/'
                    );
                    const { ancho, alto } = await obtenerTamanoImagen(String(logoUrl));
                    // @ts-ignore: Unreachable code error
                    doc.addImage(logoUrl, 'PNG', 10, offset, 40, (40 * alto) / ancho);
                    offset += 30;
                  } catch (e) {}
                  offset += 10;

                  doc.text(
                    t('device_deport_of') + ' ' + refactoredDevice?.attributes.name,
                    10,
                    offset
                  );

                  offset += 5;
                  roundedRect(doc, 10, offset, 90, 50, 0.1);
                  offset += 10;
                  doc.setFontSize(12);
                  doc.text(
                    t('identifier') + ': ' + refactoredDevice?.attributes.identifier,
                    15,
                    offset,
                    {}
                  );
                  offset += 8;
                  doc.text('Capacidad: ' + refactoredDevice.capacidad, 15, offset);
                  offset += 8;
                  doc.text(
                    t('available_charge') +
                      ': ' +
                      refactoredDevice.volumen_aproximado +
                      refactoredDevice.unit,
                    15,
                    offset
                  );
                  offset += 8;
                  doc.text(
                    t('liters_available') +
                      ': ' +
                      refactoredDevice.volumen_libre +
                      refactoredDevice.unit,
                    15,
                    offset
                  );
                  offset += 8;
                  doc.text(
                    t('percent') + ': ' + Math.round(refactoredDevice.percent * 10) / 10 + '%',
                    15,
                    offset
                  );

                  //IMAGEN GRÁFICA
                  doc.setFontSize(12);
                  offset += 18;
                  doc.text(
                    t('chart_measurements') +
                      ' ' +
                      t('from') +
                      ' ' +
                      dayjs(dateRangeValue[0]).format(DATE_FORMAT_NO_TIME) +
                      ' ' +
                      t('to') +
                      ' ' +
                      dayjs(dateRangeValue[1]).format(DATE_FORMAT_NO_TIME),
                    10,
                    offset
                  );
                  offset += 2;
                  if (canva instanceof HTMLCanvasElement) {
                    doc.addImage(
                      canva,
                      'JPEG',
                      10,
                      offset,
                      185,
                      (185 * canva.height) / canva.width
                    );
                  }
                  offset += (185 * canva.height) / canva.width + 5;

                  // TABLA
                  doc.text(t('received_data'), 10, offset);
                  offset += 8;
                  let head: string[] = [];
                  const headers = document.querySelectorAll(
                    '#tabla-datos-recibidos > thead > tr > th'
                  );
                  headers.forEach((th) => {
                    head.push(th.innerHTML);
                  });
                  let body: [string[]] = [[]];
                  const rows = document.querySelectorAll('#tabla-datos-recibidos > tbody > tr');

                  rows.forEach((tr) => {
                    let row: string[] = [];
                    tr.querySelectorAll('td').forEach((td) => {
                      row.push(td.innerHTML);
                    });
                    row.pop(); // Eliminamos el último porque es el botón editar.
                    body.push(row);
                  });
                  body.shift(); //Eliminamos el primero porque está vacío.
                  head.pop(); // Eliminamos el último por que es el head de editar.
                  const datos = [head, ...body];
                  const opciones = {
                    theme: 'grid',
                    headStyles: { fillColor: [22, 160, 133] }, // Estilo de la cabecera
                    margin: { top: 10, left: 10 },
                    startY: offset
                  };
                  // @ts-ignore: Unreachable code error
                  doc.autoTable({
                    head: [datos[0]],
                    body: datos.slice(1),
                    ...opciones
                  });
                  offset += 18;

                  doc.save('DeviceReport' + refactoredDevice.attributes.name + '.pdf');
                  setLoading(false);
                });
              }
              setLoading(false);
            }}
            color="primary"
          >
            {t('download_pdf')}
          </LoadingButton>
        </div>
      </div>
      {/* {checkWorkspace(workspace, ['repsol', 'gam', 'htgroup']) && (
        <div className="contacto cuadro-azul cuadro-redondeado">
          <h3>{t('contact')}</h3>
          <div className="groups">
            <div className="group">
              <label>{t('do_you_have_doubts')}</label>
              <label>{t('contact_with_distributor')}</label>
            </div>
          </div>
          <div className="groups">
            <div className="group">
              <div className="detail">{t('contact_name')}</div>
              <label>+34 917 53 94 00</label>
              <label style={{ width: '100%' }}>
                <a href="mailto:crcpedidoso@repsol.com">crcpedidos@repsol.com</a>
              </label>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default DeviceDetailsInfo;
